import { makeStyles, Text } from '@rneui/themed'
import { font } from 'app/theme'
import { Shift } from '@nextforce/api'
import React from 'react'
import { SHIFT_NOTE_HEIGHT } from './note'

interface Props {
  shift: Shift
}

export function ShiftBonusView(props: Props) {
  const styles = useStyles()

  if (!props.shift.bonus?.amount) {
    return null
  }

  return (
    <Text style={styles.container} numberOfLines={1}>
      {`${props.shift.note ? ' ' : ''}+$${props.shift.bonus?.amount}`}
    </Text>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    height: SHIFT_NOTE_HEIGHT,
    fontSize: 13,
    fontFamily: font.bold,
    color: 'white',
    textAlignVertical: 'center',
    lineHeight: SHIFT_NOTE_HEIGHT,
    marginHorizontal: 5,
  },
}))
